<template>
  <section class="new-item">
    <i class="fas fa-plus-circle" @click="showForm = !showForm" :class="{'open':showForm}"></i>
    <form v-if="showForm" class="form-items" @submit.prevent="createItem">
      <input
        v-model="item.name"
        type="text"
        name="name"
        placeholder="Item name here"
        @keydown="closeInput"
      >
    </form>
  </section>
</template>

<script>
import uuidv1 from "uuid/v1";

import { EventBus } from "@/eventbus";

import db from "@/fb/init";
import firebase from "firebase/app";

export default {
  name: "NewItem",
  props: ["list"],
  data() {
    return {
      showForm: false,
      item: {
        name: null,
        list_id: null,
        board_id: null,
        item_id: null,
        imageUrl: null,
        dueDate: null,
        externalLink: null,
        done: false,
        special: false,
        status: "not-started"
      },
      flashMessage: {
        message: null,
        status: null
      }
    };
  },
  methods: {
    createItem() {
      if (this.item.name) {
        EventBus.$emit("clearFlash");
        this.item.board_id = this.list.board_id;
        this.item.list_id = this.list.list_id;
        this.item.item_id = uuidv1();
        const item = Object.assign({}, this.item);
        // this.$store.dispatch("addItem", item);
        this.addToDb(item);
        this.item.name = null;
      } else {
        const messageObj = {
          message: "We need some sort of name",
          status: "error",
          duration: 3000
        };
        EventBus.$emit("showFlash", messageObj);
      }
    },
    addToDb(item) {
      db.collection("boards")
        .doc(item.board_id)
        .collection("lists")
        .doc(item.list_id)
        .update({
          items: firebase.firestore.FieldValue.arrayUnion(item)
        })
        .catch(err => {
          window.console.log(err);
        });
    },
    closeInput(e) {
      if (e.which === 27) {
        this.showForm = false;
      }
    }
  }
};
</script>
